import { AirportPopup } from './AirportPopup';
import { MoneyCounter } from './MoneyCounter';
import { DATA } from '../../game/data';
import { AdvancePopup } from './AdvancePopup';
import { Popups } from './Popups/Popups';
import { BigButton } from './Reusable/BigButton';
import { IMAGES } from '../../game/data/images';
import { RewardIndicator } from './RewardIndicator';
import { OfflineIncomePopup } from './OfflineIncomePopup';
import { SIDEBAR_WIDTH } from '../Map/WorldMap';
import { AdvanceButton } from '../advance/AdvanceButton';
import { AudioButtons } from './AudioButtons';

export const MainUI: React.FC = () => {
  return (
    <>
      <AudioButtons />
      <MoneyCounter />
      <div style={{ position: 'absolute', top: 8, right: 8, display: 'flex', gap: 4 }}>
        <AdvanceButton />
      </div>
      <RewardIndicator />
      <Popups />
      <AirportPopup />
      <AdvancePopup />
      <OfflineIncomePopup />
    </>
  );
};
